'use client'
import { useStdCart } from 'storefront-modules/cart'
import { useAnalyticsCart } from 'storefront-modules/third-party'
import { useSelector } from 'shared-redux'
import { Currency } from 'ecosystem'
import { selectedCart } from 'shared-redux/state'
import appConfig from '#/src/appConfig'
import { overrideText } from 'ui/lib/overrides'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { CurrencyOverrides } from 'storefront-modules/types'

interface UseCustomCartProps {
  registerViewCartEvent?: boolean
}

export const useCustomCart = (opts?: UseCustomCartProps) => {
  const overrides = useOverridesContext<keyof CurrencyOverrides>()
  const state = useSelector(selectedCart)
  const { checkoutEvent, purchaseEvent, addToCartEvent, removeFromCartEvent, viewCartEvent } =
    useAnalyticsCart({
      categories: appConfig.categories,
      cartTotal: state.cartTotal,
      cartItems: state.cartItems,
      currency: overrideText(appConfig.currency ?? Currency.SEK, overrides?.currency) as Currency,
      registerViewCartEvent: !!opts?.registerViewCartEvent
    })

  return useStdCart({
    onAddToCart: addToCartEvent,
    onRemoveFromCart: removeFromCartEvent,
    onCheckout: checkoutEvent,
    onPurchase: purchaseEvent,
    onViewCart: viewCartEvent
  })
}
